module.exports = __webpack_public_path__ + "img/pic4.8a7938c6.jpg";